import { Dayjs } from 'dayjs'

import { getOnlyDate } from '~/astra'

export type AnyDate = Dayjs | string

export function getDateKey(date: AnyDate): string {
    return getOnlyDate(date)
}

export function getDateLocationIdKey(date: AnyDate, locationId: number): string {
    return `${locationId} :: ${getDateKey(date)}`
}
